import {
    createHook,
    createStore,
    StoreActionApi,
} from "react-sweet-state";
import { Document } from "entities/UIModel/Document";

type State = {
    isUWAGridInEditMode: boolean;
    isUWAGridInShowToastMode: boolean;
    selectedUWAGridItems: Document[];
};

type StoreApi = StoreActionApi<State>;
type Actions = typeof actions;

const actions = {
    setUWAGridInEditMode:
        (isUWAGridInEditMode: boolean) =>
            ({ setState }: StoreApi) => {
                setState({ isUWAGridInEditMode });
            },
    // setUWAInShowToastMode:
    //     (isUWAGridInShowToastMode: boolean) =>
    //         ({ setState }: StoreApi) => {
    //             setState({ isUWAGridInShowToastMode });
    //         },
    updateSelectedUWAGridItem:
        (item: Document) =>
            ({ setState, getState }: StoreApi) => {
                const currentItems = getState().selectedUWAGridItems || [];
                const updatedItems = currentItems?.filter(
                    (d) => d.documentID !== item.documentID
                );

                if (updatedItems.length === currentItems?.length) {
                    updatedItems.push(item);
                }

                setState({
                    selectedUWAGridItems: updatedItems,
                });
            },
    // updateSelectedUWAGridItems:
    //     (items: Document[], orderID?: number) =>
    //         ({ setState, getState }: StoreApi) => {

    //             const currentSelectedAllItems =
    //                 getState().selectedUWAGridItems || [];

    //             const currentSelectedOrderItems = currentSelectedAllItems?.filter((d) => d.orderID === orderID);
    //             const currentSelectedOtherItems = currentSelectedAllItems?.filter((d) => d.orderID !== orderID);

    //             const newOrderItems = items.filter(
    //                 (item) =>
    //                     !currentSelectedOrderItems?.find(
    //                         (currentItem) =>
    //                             currentItem.documentID === item.documentID
    //                     )
    //             );

    //             let updatedOrderItems: Document[] = [];
    //             if (newOrderItems.length > 0) {
    //                 updatedOrderItems = currentSelectedOrderItems?.concat(newOrderItems);
    //             }


    //             let updatedItems: Document[] = [];
    //             if (updatedOrderItems.length > 0 || currentSelectedOtherItems?.length > 0) {
    //                 updatedItems = currentSelectedOtherItems?.concat(updatedOrderItems);
    //             }
    //             setState({
    //                 selectedUWAGridItems: updatedItems,
    //             });
    //         },
    resetSelectedUWAGridItems:
        (orderID?: number) =>
            ({ getState, setState }: StoreApi) => {
                const currentUWAGridItems =
                    getState().selectedUWAGridItems || [];
                const updatedItems = currentUWAGridItems?.filter((d) => d.orderID !== orderID);
                setState({
                    selectedUWAGridItems: updatedItems,
                });
            },

};

const Store = createStore<State, Actions>({
    initialState: {
        isUWAGridInEditMode: false,
        isUWAGridInShowToastMode: false,
        selectedUWAGridItems: [],
    },
    actions,
    name: "uwa"
});


const useUWAActions = createHook(Store, {
    selector: null,
});

const getUWAGridStates = (state: State) => ({
    isUWAGridInEditMode: state.isUWAGridInEditMode,
    isUWAGridInShowToastMode: state.isUWAGridInShowToastMode,
})

const getUWAGridItems = (state: State) => ({
    selectedUWAGridItems: state.selectedUWAGridItems,
})

const useUWAGridItems = createHook(Store, {
    selector: getUWAGridItems,
})

const useUWAGridStates = createHook(Store, {
    selector: getUWAGridStates,
});

export {
    useUWAActions,
    useUWAGridStates,
    useUWAGridItems,
};
